'use client';
import { ReactElement } from 'react';
import { CatInputField } from '@blocks-react/components/InputField';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import { useController, useFormContext } from 'react-hook-form';
import { RulesFromHookFormType } from '../types';
import styles from './MyEquipmentSerialInput.module.scss';

interface MyEquipmentSerialInputProps {
  placeholder: string;
  name: string;
  rules: RulesFromHookFormType;
  fieldNote?: string | null;
  isError?: boolean | null;
  maxLength?: number;
  onChange: (e: string) => void;
  children?: ReactElement;
  dataCsMask?: boolean;
}

export const MyEquipmentSerialInput = ({
  placeholder,
  name,
  rules,
  fieldNote,
  isError,
  maxLength,
  onChange,
  children,
  dataCsMask
}: MyEquipmentSerialInputProps) => {
  const { control, getValues, setValue } = useFormContext();
  const { field, fieldState } = useController({ name, control, rules });
  const serialNumber = getValues(name);
  const error = !!(isError ?? fieldState.error);
  const note = fieldNote ?? fieldState.error?.message;
  const onBlChange = (e: BlocksChangeEvent): void => {
    const inputValue = e.detail.value;
    if (serialNumber !== inputValue) {
      onChange(inputValue);
      field.onChange(e);
      setValue(name, inputValue);
    }
  };
  return (
    // TODO - Input Validation - Ensure that <,>,/,\ characters and <script> tags are not allowed to type/paste.
    <CatInputField
      hideLabel
      type="text"
      placeholder={placeholder}
      onBlChange={onBlChange}
      fieldNote={note}
      status={error ? 'error' : undefined}
      name={name}
      value={serialNumber}
      maxlength={maxLength}
      data-testid="serial_input_form"
      data-cs-encrypt={dataCsMask}
      className={styles['serial_input']}
    >
      {children}
    </CatInputField>
  );
};
